import { render, staticRenderFns } from "./StudentListHeader.vue?vue&type=template&id=8e353d02&"
import script from "./StudentListHeader.vue?vue&type=script&lang=js&"
export * from "./StudentListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/maplebear-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VCheckbox,VLayout,VSubheader})
